import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Price from './Price';
import { useFinance } from '../SelectProductsContext/SelectProductsProvider';

const PricingDetails = ({ pricing, isSellingProvince, frieghtPDIFeesCost }) => {
  const { t } = useTranslation();
  const sellingPriceLabel = t('Sub-apps.PriceAndFinance.sellingPriceLabel');
  const msrpPriceLabel = t('Shared.Common.msrpStartingFromLabel');
  const sellingPriceWithTaxTooltipLabel = t('Sub-apps.PriceAndFinance.sellingPriceWithTaxTooltipLabel');
  const sellingPriceNoTaxTooltipLabel = t('Sub-apps.PriceAndFinance.sellingPriceNoTaxTooltipLabel');
  const msrpWithTaxTooltipLabel = t('Sub-apps.PriceAndFinance.msrpWithTaxTooltipLabel');
  const msrpNoTaxTooltipLabel = t('Sub-apps.PriceAndFinance.msrpNoTaxTooltipLabel');

  const includesSalesTaxLabel = t('Sub-apps.PriceAndFinance.includeSalesTaxLabel');

  const [finance, setFinance] = useFinance();

  const hasDiscount = pricing?.discount > 0;
  const totalDiscount = hasDiscount ? pricing?.discount : undefined;
  const discountedPrice = hasDiscount ? pricing?.msrpDiscountprice : undefined;
  const noDiscountPrice = pricing?.msrpNonDiscountprice;

  return (
    <Price
      price={pricing?.msrpDiscountprice}
      isSellingProvince={isSellingProvince}
      hasDiscount={hasDiscount}
      totalDiscount={totalDiscount}
      discountedPrice={discountedPrice}
      noDiscountPrice={noDiscountPrice}
      withTaxToolTipLabel={isSellingProvince ? sellingPriceWithTaxTooltipLabel : msrpWithTaxTooltipLabel}
      noTaxToolTipLabel={isSellingProvince ? sellingPriceNoTaxTooltipLabel : msrpNoTaxTooltipLabel}
      priceLabel={isSellingProvince ? sellingPriceLabel : msrpPriceLabel}
      includesSalesTax={finance.includesSalesTax}
      setIncludesSalesTax={setFinance}
      includesSalesTaxLabel={includesSalesTaxLabel}
      frieghtPDIFeesCost={frieghtPDIFeesCost}
    />
  );
};

PricingDetails.propTypes = {
  pricing: PropTypes.shape({
    discount: PropTypes.number,
    fees: PropTypes.number,
    includeFees: PropTypes.bool,
    msrpDiscountprice: PropTypes.number,
    msrpNonDiscountprice: PropTypes.number,
    total: PropTypes.number,
    value: PropTypes.number,
  }),
  isSellingProvince: PropTypes.bool,
  frieghtPDIFeesCost: PropTypes.number,
};

export default PricingDetails;
